module.exports = __webpack_public_path__ + "img/底部.9c96f831.png";